import { theme, breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Shell = styled.div<{ background?: string }>`
  background: ${({ background = theme.color.background.primary }) =>
    background};
  width: 100vw;
  height: 90vh;
  max-height: 54.25rem;

  border-radius: 0.25rem;

  @keyframes multistepModalMountAnimation {
    from {
      transform: translateY(2rem);
      opacity: 0.7;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  animation: multistepModalMountAnimation 0.25s ease-in-out;

  @media (min-width: ${breakpoints.md}) {
    width: calc(100vw - 2rem);
    max-width: 88rem;

    height: calc(100vh - 2rem);
  }

  // todo: styleguide breakpoint?
  @media (min-width: 1680px) {
    margin: 5rem auto auto;
    height: calc(100vh - 10rem);
  }
`;

const HEADER_HEIGHT = '3.75rem';
export const Content = styled.div`
  height: calc(100% - ${HEADER_HEIGHT});
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: ${HEADER_HEIGHT};

  padding: 0.5rem;
`;

export const IconButton = styled.button`
  background: transparent;
  border: none;
  padding: 1rem;
  cursor: pointer;
`;

export const Title = styled.span`
  ${theme.typography.labelRegular400};
`;

export const StepWrapper = styled.div`
  width: 100%;
  background: ${theme.color.background.disabled};
  height: 0.125rem;
`;
export const StepIndicator = styled.div<{
  currentStep: number;
  totalSteps: number;
}>`
  width: ${(props) => `${(props.currentStep / props.totalSteps) * 100}%`};
  height: 100%;
  background: ${({ currentStep, totalSteps }) =>
    currentStep === totalSteps
      ? theme.color.background.disabled
      : theme.color.background.inverse};

  transition: all 0.2s ease-in;
`;

export const Background = styled.div`
  display: flex;
  align-items: flex-end;

  width: 100vw;
  height: 100vh;

  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;

  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);

  @media (min-width: ${breakpoints.md}) {
    justify-content: center;
    align-items: center;
  }

  @media (min-width: 1680px) {
    align-items: unset;
  }
`;
